<script>
import { ref, computed, onMounted } from 'vue'
import { UploadFilled, LocationFilled } from '@element-plus/icons-vue'
import axios from 'axios'
import { ElMessage } from 'element-plus'
import { validatePhotoUpload, resolveProfilePhotoUrl } from '@/utils/photoUpload'
import {  useRouter } from 'vue-router'

export default {
  name: 'CreateMomentView',
  components: {
    UploadFilled,
    LocationFilled
  },
  setup() {

    // const route = useRoute()
    const router = useRouter()

    console.log(localStorage.getItem('jwt_token'))
    const form = ref({
      content: '',
      images: [],
      visibility: 'public',
      isTopic: false,
      friendShow: false,
      topicId: null,
      location: {
        province: '',
        city: '',
        region: '',
        landmark: '',
        longitude: '',
        latitude: ''
      }
    })

    const loading = ref(false)
    const imageList = ref([])
    const locationDialogVisible = ref(false)
    const userAvatar = ref('')
    const userName = ref('')

    onMounted(() => {
      try {
        const u = JSON.parse(localStorage.getItem('user_info') || '{}')
        userAvatar.value = resolveProfilePhotoUrl(u.avatar, u.photo)
        userName.value = u.nickname || u.username || ''
      } catch {
        userAvatar.value = ''
        userName.value = ''
      }
    })

    const authHeaders = computed(() => ({
      'Authorization': `Bearer ${localStorage.getItem('jwt_token')}`
    }))

    const beforeUpload = (file) => validatePhotoUpload(file, ElMessage.error)

    const customUpload = async (options) => {
      const { file, onSuccess, onError } = options
      const formData = new FormData()
      formData.append('file', file)

      try {
        const response = await axios.post('/api/v1/upload', formData, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('jwt_token')}`,
            'Content-Type': 'multipart/form-data'
          }
        })

        if (response.data.code === 200) {
          imageList.value.push(response.data.message)
          form.value.images = imageList.value
          onSuccess(response.data)
          ElMessage.success('图片上传成功')
        } else {
          onError(new Error(response.data.message || '上传失败'))
          ElMessage.error('图片上传失败')
        }
      } catch (error) {
        onError(error)
        console.log(error)
        ElMessage.error('图片上传失败，请重试')
      }
    }

    const handleImageRemove = (file) => {
      const index = imageList.value.indexOf(file.url)
      if (index !== -1) {
        imageList.value.splice(index, 1)
        form.value.images = imageList.value
      }
    }

    const handleLocationSelect = (location) => {
      form.value.location = {
        ...form.value.location,
        ...location
      }
      locationDialogVisible.value = false
    }

    const submitForm = async () => {
      try {
        loading.value = true
        const token = localStorage.getItem('jwt_token')
        if (!token) {
          ElMessage.error('请先登录')
          return
        }

        const response = await axios.post('/api/v1/moment/create', {
          content: form.value.content,
          images: form.value.images,
          visibility: form.value.visibility,
          isTopic: form.value.isTopic,
          friendShow: form.value.friendShow,
          topicId: form.value.topicId,
          province: form.value.location.province,
          city: form.value.location.city,
          region: form.value.location.region,
          landmark: form.value.location.landmark,
          longitude: form.value.location.longitude,
          latitude: form.value.location.latitude
        }, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        })

        if (response.data.code === 200) {
          ElMessage.success('发布成功')
          // 清空表单
          form.value = {
            content: '',
            images: [],
            visibility: 'public',
            isTopic: false,
            friendShow: false,
            topicId: null,
            location: {
              province: '',
              city: '',
              region: '',
              landmark: '',
              longitude: '',
              latitude: ''
            }
          }
          imageList.value = []
          router.push('/moment')
        } else {
          ElMessage.error(response.data.message || '发布失败')
        }
      } catch (error) {
        console.error('Error creating moment:', error)
        ElMessage.error('发布失败，请重试')
      } finally {
        loading.value = false
      }
    }

    return {
      form,
      loading,
      imageList,
      locationDialogVisible,
      userAvatar,
      userName,
      authHeaders,
      beforeUpload,
      customUpload,
      handleImageRemove,
      handleLocationSelect,
      submitForm
    }
  }
}
</script>

<template>
  <div class="create-moment">
    <div class="container">
      <h2>发布动态</h2>
      <p class="page-lead">写一条动态，分享到「认识人 → 动态」。</p>

      <div class="compose-user">
        <el-avatar :size="48" :src="userAvatar">
          {{ userName?.charAt(0) || '我' }}
        </el-avatar>
        <span class="compose-name">{{ userName || '我' }}</span>
      </div>
      
      <el-form :model="form" label-width="80px">
        <el-form-item label="内容">
          <el-input
            v-model="form.content"
            type="textarea"
            :rows="4"
            placeholder="分享你的想法..."
          />
        </el-form-item>

        <el-form-item label="图片">
          <el-upload
            action="#"
            list-type="picture-card"
            :auto-upload="true"
            :before-upload="beforeUpload"
            :http-request="customUpload"
            :on-remove="handleImageRemove"
            :headers="authHeaders"
            accept="image/*"
          >
            <el-icon><UploadFilled /></el-icon>
          </el-upload>
        </el-form-item>

        <el-form-item label="可见性">
          <el-radio-group v-model="form.visibility">
            <el-radio label="public">公开</el-radio>
            <el-radio label="friends">好友可见</el-radio>
            <el-radio label="private">私密</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="位置">
          <el-button
            type="primary"
            @click="locationDialogVisible = true"
          >
            <el-icon><LocationFilled /></el-icon>
            选择位置
          </el-button>
          <div v-if="form.location.landmark" class="location-info">
            {{ form.location.landmark }}
          </div>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            :loading="loading"
            @click="submitForm"
          >
            发布
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 位置选择对话框 -->
    <el-dialog
      v-model="locationDialogVisible"
      title="选择位置"
      width="500px"
    >
      <!-- 这里可以集成地图组件或位置选择器 -->
      <div class="location-picker">
        <el-input v-model="form.location.landmark" placeholder="输入位置名称" />
        <el-input v-model="form.location.province" placeholder="省份" />
        <el-input v-model="form.location.city" placeholder="城市" />
        <el-input v-model="form.location.region" placeholder="区/县" />
        <el-input v-model="form.location.longitude" placeholder="经度" />
        <el-input v-model="form.location.latitude" placeholder="纬度" />
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="locationDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleLocationSelect(form.location)">
            确定
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<style scoped>
.create-moment {
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
}

.page-lead {
  margin: -4px 0 16px;
  color: #606266;
  font-size: 14px;
  line-height: 1.5;
}

.compose-user {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
  padding: 12px 16px;
  background: #f5f7fa;
  border-radius: 8px;
}

.compose-name {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.container {
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

h2 {
  color: var(--el-text-color-primary);
  margin-bottom: 20px;
  font-size: 24px;
}

.location-info {
  margin-top: 10px;
  color: var(--el-text-color-regular);
}

.location-picker {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style> 